import { fetchAddFavorite } from '../../shared/repositories/favorites/v1/add-favorite';
import { EDealType, EEntityType } from '../../shared/repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
export async function addFavorites(_ref) {
  let {
    httpApi,
    logger,
    params
  } = _ref;
  const parameters = {
    dealType: EDealType.Sale,
    entityType: EEntityType.OfferResidental,
    entityId: params.offerId
  };
  try {
    await fetchAddFavorite({
      httpApi,
      parameters
    });
  } catch (error) {
    logger.error(error, {
      offerId: params.offerId,
      domain: 'addFavorite'
    });
    return false;
  }
  return true;
}